const steps = [
  {
    num: 1,
    icon: 'ri-chat-3-line',
    title: '了解現況與需求',
    desc: '透過輕鬆的對話，了解您目前的生活狀況、家庭結構、財務目標與對保障的期待，不急著推薦，先把您的故事聽完。',
  },
  {
    num: 2,
    icon: 'ri-file-list-3-line',
    title: '整理既有保單與保障內容',
    desc: '協助您整理現有的所有保單，清楚列出每張保單的保障範圍、保費支出與受益人設定，讓您一目了然。',
  },
  {
    num: 3,
    icon: 'ri-search-2-line',
    title: '分析保障缺口與重複配置',
    desc: '對照您的需求與現有保障，找出哪些地方保障不足、哪些地方有重複投保，提供客觀的分析報告。',
  },
  {
    num: 4,
    icon: 'ri-draft-line',
    title: '提出調整建議與優先順序',
    desc: '根據分析結果，提出具體可行的調整建議，並依照預算與優先順序排列，讓您清楚知道下一步該怎麼做。',
  },
  {
    num: 5,
    icon: 'ri-refresh-line',
    title: '建立年度追蹤與定期檢視機制',
    desc: '保障不是一次性的事，每年定期回訪，根據您人生階段的變化（結婚、生子、換工作、退休）適時調整保障內容。',
  },
];

export default function ServicesProcess() {
  return (
    <section id="health-check-section" className="bg-[#F8F5F0] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            HOW IT WORKS
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            保單健檢怎麼進行？
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4 mb-6"></div>
          <p className="text-gray-600 max-w-xl mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            透明、清晰的五步驟流程，讓您清楚知道每個環節在做什麼
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-6 max-w-3xl mx-auto mb-20">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className="flex items-start gap-6 bg-white rounded-2xl p-7 border border-transparent hover:border-[#D4A373]/30 transition-all duration-200"
            >
              {/* Number + Icon */}
              <div className="flex flex-col items-center gap-2 flex-shrink-0">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#5C5470] text-white font-bold font-serif"
                  style={{ fontSize: '1.1875rem' }}>
                  {step.num}
                </div>
                {i < steps.length - 1 && (
                  <div className="w-px h-6 bg-gray-200"></div>
                )}
              </div>

              {/* Content */}
              <div className="flex-1 pt-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#D4A373]/15">
                    <i className={`${step.icon} text-[#D4A373]`} style={{ fontSize: '1.0625rem' }}></i>
                  </div>
                  <h3
                    className="font-serif font-bold text-[#5C5470]"
                    style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)', lineHeight: '1.45' }}
                  >
                    Step {step.num}：{step.title}
                  </h3>
                </div>
                <p className="text-gray-600" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Block */}
        <div className="bg-[#5C5470] rounded-3xl p-10 lg:p-14">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            <div className="text-center lg:text-left">
              <h2
                className="font-serif font-bold text-white mb-4"
                style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
              >
                不確定自己目前保障夠不夠？
              </h2>
              <p
                className="text-white/75 max-w-lg"
                style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
              >
                先不用急著買新的保單，讓我們從保單健檢開始，
                找出真正需要補強的地方。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row lg:flex-col gap-4 flex-shrink-0">
              <a
                href="#health-check-form-svc"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('health-check-form-svc')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105 cursor-pointer"
                style={{ fontSize: '1.1875rem' }}
              >
                <i className="ri-file-search-line"></i>
                免費保單健檢
              </a>
              <a
                href="https://lin.ee/6XFYSq2"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:border-white hover:bg-white/10 transition-all duration-200"
                style={{ fontSize: '1.1875rem' }}
              >
                <i className="ri-line-fill"></i>
                加入 LINE 諮詢
              </a>
            </div>
          </div>
        </div>

        {/* Health Check Form */}
        <div id="health-check-form-svc" className="mt-16 bg-white rounded-3xl p-10 lg:p-14 border border-[#D4A373]/20">
          <div className="max-w-2xl mx-auto">
            <h3
              className="font-serif font-bold text-[#5C5470] mb-2 text-center"
              style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
            >
              免費保單健檢申請
            </h3>
            <p className="text-gray-500 text-center mb-8" style={{ fontSize: '1.0625rem' }}>
              填寫以下資料，琮恩將在 1–2 個工作天內與您聯繫
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d7oe6t0ltb4nd0kphc50"
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
                try {
                  const res = await fetch('https://readdy.ai/api/form/d7oe6t0ltb4nd0kphc50', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: data.toString(),
                  });
                  if (res.ok) {
                    const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                    if (btn) { btn.textContent = '✓ 已送出，我們將盡快聯繫您！'; btn.disabled = true; }
                    form.reset();
                  }
                } catch {
                  alert('送出失敗，請稍後再試');
                }
              }}
              className="space-y-5"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>姓名 *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="您的姓名"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                    style={{ fontSize: '1.0625rem' }}
                  />
                </div>
                <div>
                  <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>電話 *</label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    placeholder="09XX-XXX-XXX"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                    style={{ fontSize: '1.0625rem' }}
                  />
                </div>
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>電子郵件</label>
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors"
                  style={{ fontSize: '1.0625rem' }}
                />
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>感興趣的服務</label>
                <select
                  name="service_interest"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors bg-white cursor-pointer"
                  style={{ fontSize: '1.0625rem' }}
                >
                  <option value="">請選擇</option>
                  <option value="personal_medical">個人醫療保險</option>
                  <option value="family_protection">家庭醫療保障</option>
                  <option value="asset_risk">資產與風險管理</option>
                  <option value="corporate">企業與團體方案</option>
                  <option value="health_check">保單健檢</option>
                </select>
              </div>
              <div>
                <label className="block text-[#5C5470] font-medium mb-2" style={{ fontSize: '1.0625rem' }}>想說的話</label>
                <textarea
                  name="message"
                  rows={3}
                  maxLength={500}
                  placeholder="例如：我有幾張舊保單，想知道保障夠不夠…"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-700 focus:outline-none focus:border-[#D4A373] transition-colors resize-none"
                  style={{ fontSize: '1.0625rem' }}
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-[#D4A373] text-white py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-[1.02]"
                style={{ fontSize: '1.1875rem' }}
              >
                送出申請
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
